<template>
  <el-dialog
      title="驳回加价"
      :visible.sync="visible"
      @close="close"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add">
        <div class="gengjiun">
          <div class="modal-tit">驳回原因</div>
          <el-input
            type="textarea"
            placeholder="请描述"
            v-model="remark"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
</template>

<script>
import { postAction } from "@/api/manage";

export default {
  data () {
    return {
      visible:false,
      loading:false,
      remark:'',
      record:{}
    }
  },

  methods: {
    init(item={}){
      this.record=item
      this.visible=true
    },
    submit(){
      if(!this.remark) return this.$message.error('请输入驳回原因')
      this.loading=true
      postAction('/order/api/markup/reject',{
        markupRequestId:this.record.id,
        rejectContent:this.remark
      }).then(({data})=>{
        if(data.code==0){
          this.$message.success('驳回成功')
          this.$emit('ok')
          this.close()
        }
      }).finally(()=>{
        this.loading=false
      })
    },
    close(){
      this.visible=false
      this.remark=''
    }
  }
}
</script>

<style lang='scss' scoped>
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

</style>
